import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { TagModalChip } from './chip';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader } from '@livable/saas-react-components';
import { Autocomplete, Button, TextField } from '@mui/material';
import { useStore } from 'src/stores';
import { toJS } from 'mobx';
import { TAG_COLORS } from 'src/constants/tag';
export const TagModalForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    tags = _ref.tags,
    companyId = _ref.companyId,
    trigger = _ref.trigger;
  const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(toJS(store.tags.tagsList)),
    _useState2 = _slicedToArray(_useState, 2),
    searchResultItems = _useState2[0],
    setSearchResultItems = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tagsValue = _useState4[0],
    setTagsValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoad = _useState6[0],
    setIsLoad = _useState6[1];
  const handleStreetSearch = e => {
    const searchValue = e.target.value.trim().replace(/  +/g, ' ');
    const searchResp = toJS(store.tags.tagsList).filter(i => i.name.toUpperCase().includes(searchValue.toUpperCase()));
    if (searchResp.length === 0) {
      setSearchResultItems([{
        name: searchValue
      }]);
      return;
    }
    setSearchResultItems(searchResp);
  };
  const handleChange = async (event, newValue) => {
    var _newValue;
    if (newValue.length && !((_newValue = newValue[newValue.length - 1]) !== null && _newValue !== void 0 && _newValue.color)) {
      const temp = [...newValue];
      const newObj = temp.splice(-1)[0];
      const resp = await store.tags.createTagAsync.run({
        name: newObj.name,
        color: TAG_COLORS[0]
      });
      setTagsValue([...temp, {
        name: newObj.name,
        color: TAG_COLORS[0],
        id: resp.response,
        isEditable: true
      }]);
    } else {
      setTagsValue(newValue);
    }
    setSearchResultItems(toJS(store.tags.tagsList));
  };
  const handleDelete = async (id, isEditable) => {
    setIsLoad(true);
    const temp = [...tagsValue];
    const currentIndex = temp.findIndex(i => i.id === id);
    temp.splice(currentIndex, 1);
    setTagsValue(temp);
    if (isEditable) {
      await store.tags.deleteTagAsync.run({
        tagId: id
      });
    }
    setTimeout(() => {
      setIsLoad(false);
    }, 100);
  };
  const handleSubmit = async () => {
    const result = tagsValue.map(i => i.id);
    const newIds = result.filter(x => !tags.includes(x));
    const oldIds = tags.filter(x => !result.includes(x));
    if (newIds.length) {
      await store.tags.assignTagsToAccountAsync.run({
        companyId: companyId,
        idx: newIds
      });
    }
    if (oldIds.length) {
      await store.tags.removeTagsFromAccountAsync.run({
        companyId: companyId,
        idx: oldIds
      });
    }
    handleModalClose();
    trigger();
  };
  useEffect(() => {
    const data = [];
    tags.map(i => {
      data.push(toJS(store.tags.getTagById(i)));
    });
    setTagsValue(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.addNew
  }, !isLoad && /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    variant: "plain",
    id: "tags-standard",
    value: tagsValue,
    onChange: handleChange,
    options: searchResultItems,
    getOptionLabel: option => option.name,
    renderTags: (value, getTagProps) => value.map((option, index) => /*#__PURE__*/React.createElement(TagModalChip, _extends({
      key: index,
      data: option,
      handleDelete: handleDelete
    }, getTagProps({
      index
    })))),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: t('admin_page.select_tags'),
      onChange: handleStreetSearch
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '433-TagModal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: handleSubmit,
    disabled: isLoad || store.tags.createTagAsync.inProgress || store.tags.getAllTagsAsync.inProgress || store.tags.updateTagAsync.inProgress || store.tags.deleteTagAsync.inProgress || store.tags.getTagByIdAsync.inProgress || store.tags.assignTagsToAccountAsync.inProgress || store.tags.removeTagsFromAccountAsync.inProgress || store.tags.getAllTagsByAccountIdsAsync.inProgress,
    'custom-attribute': '434-TagModal'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoad || store.tags.createTagAsync.inProgress || store.tags.getAllTagsAsync.inProgress || store.tags.updateTagAsync.inProgress || store.tags.deleteTagAsync.inProgress || store.tags.getTagByIdAsync.inProgress || store.tags.assignTagsToAccountAsync.inProgress || store.tags.removeTagsFromAccountAsync.inProgress || store.tags.getAllTagsByAccountIdsAsync.inProgress
  }));
});